module.exports = __webpack_public_path__ + "static/media/linkedin_logo_claro.d1bc3d98.webp";